import { Component, OnInit, ChangeDetectorRef, ViewChild } from '@angular/core';
import { NavController, MenuController, LoadingController, AlertController, IonDatetime } from '@ionic/angular';

import { Constants } from '../../models/constants';

import { UserService } from '../../services/user-service';
import { Alert } from '../../services/alert';
import { MetaTagService } from '../../services/meta-tag-service';

import * as moment from "moment";

import { ObservableService } from 'src/app/services/observable-service';
import { BusinessAnalyticsTasks, OverallAnalytics, ProSummary } from '../../services/business-analytics-tasks';
import { Util } from '../../services/util';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';

@Component({
  selector: 'app-business-analytics',
  templateUrl: './business-analytics.page.html',
  styleUrls: ['./business-analytics.page.scss'],
})
export class BusinessAnalyticsPage implements OnInit {

  @ViewChild('ionStartDate', { read: IonDatetime }) ionStartDate: IonDatetime;
  @ViewChild('ionEndDate', { read: IonDatetime }) ionEndDate: IonDatetime;

  startOf2020 = new Date('January 1, 2020');
  yesterday = Util.daysAgo(1);

	placeholderImg = "assets/img/profile-placeholder.png";
  formatCost = Util.formatCost;
  dayMonthDateYear_Shorter = Util.dayMonthDateYear_Shorter;

  startDate: Date;
  endDate: Date;
  optBusinessLocationID?: string;

  overallAnalytics?: OverallAnalytics;
  proSummaries?: ProSummary[];

  constructor(
    private navCtrl: NavController,
    private observables: ObservableService,
    private changeRef: ChangeDetectorRef,
    private alert: Alert,
    private menuCtrl: MenuController,
    public userService: UserService,
    private metaTagService: MetaTagService,
    private loadingCtrl: LoadingController,
  ) {
    if (this.userService.user && !this.userService.user.type) {
      this.navCtrl.navigateForward(`/business-change-login`);
    }

    this.startDateChanged(Util.daysAgo(30));
    this.endDateChanged(this.yesterday, undefined, true);

    this.loadData()
  }

  ngOnInit() {
    this.menuCtrl.enable(true);
  }

  ionViewDidEnter() {
    this.observables.publishSetCurrentMenuRoot('/analytics')
  }

  ionViewWillEnter() {

    this.metaTagService.updateTitle('Analytics')
    this.metaTagService.updateTags({
      facebookURL: 'https://app.getshortcut.co/analytics',
      keywords: 'analytics for your salon or barbershop account',
      facebookTitle: 'Analytics | Shortcut',
      twitterTitle: 'Analytics | Shortcut',
      description: 'View total revenue and payout breakdown per Pro.',
      facebookDescription: 'View total revenue and payout breakdown per Pro.',
      twitterDescription: 'View total revenue and payout breakdown per Pro.',
    })
  }

  ionViewWillLeave() {}

  private loadData() {

    this.overallAnalytics = undefined;
    this.proSummaries = undefined;

    BusinessAnalyticsTasks.pullAggregateBusinessProReport(
      this.startDate,
      this.endDate,
      this.optBusinessLocationID,
      (overallAnalytics: OverallAnalytics, proSummaries: ProSummary[]) => {

        this.overallAnalytics = overallAnalytics
        this.proSummaries = proSummaries
        this.changeRef.detectChanges()

      }, (errorMsg: string) => {
        this.error(errorMsg)
    })
  }



  // DATES

  startDateChanged(newDate?: Date, event?: MatDatepickerInputEvent<Date>) {
    let date = newDate ?? event.value;
    this.startDate = moment(date).hour(0).minute(0).second(0).millisecond(0).toDate()
  }

  endDateChanged(newDate?: Date, event?: MatDatepickerInputEvent<Date>, skipReload?: boolean) {
    let date = newDate ?? event.value;
    if (!date) {
      // This can happen when start date is selected, and endDate is auto-cleared.
      return;
    }
    this.endDate = moment(date).hour(23).minute(59).second(59).millisecond(999).toDate()
    if (!skipReload) {
      this.loadData()
      this.changeRef.detectChanges()
    }
  }



  //
  // -- ACTIONS --
  //

  openSccToThisPage() {
    window.open(`${Constants.SCC_ADMIN_URL}/#/businessBookkeeping`, '_blank')
  }

  viewBookkeepingForPro(proID: string) {
    window.open(`${Constants.SCC_ADMIN_URL}/#/businessBookkeeping/${proID}`, '_blank')
  }

  goToPro(proLink: string) {
    this.navCtrl.navigateForward(`/pro/${proLink}`)
  }

  openPage(url: string) {
    window.open(url, '_blank')
  }

  adminChat() {
    this.observables.publishOpenNewAdminChat();
  }

  async downloadProPaymentsPdf() {

    let loader = await this.loadingCtrl.create()
    loader.present()

    BusinessAnalyticsTasks.generateBusinessProPaymentsPDF(
      this.startDate,
      this.endDate,
      (url: string) => {

        loader.dismiss()
        window.open(url, '_blank');

      }, (errorMsg: string) => {
        loader.dismiss()
        this.error(errorMsg)
    })
  }




  // Pro Status

  getProStatus(proSummary: ProSummary) {
      if (proSummary.info.active) {
        if (proSummary.earnings === 0) {
          return {
            status: 'Inactive in period',
            color: '#DDCF00',
          }
        }
        return {
          status: 'Active in period',
          color: '#5BDF67',
        }
      }

      return {
        status: 'Deactivated',
        color: '#AAAAAA',
      };
  }



  //
  // -- HELPERS --
  //

  error(msg: string) {
    this.alert.show('Error', msg)
  }

  getDate(date: Date) {
    return Util.shortMonthDayYear(date);
  }

}
